/**
 * * Obtiene las iniciales del nombre del artículo
 * @param {string} name Nombre del artículo
 * @returns {string} Iniciales del nombre del artículo en mayúsculas
 */
export const getArticleInitials = (name) => {
  return name ? name.slice(0, 2).toUpperCase() : "";
};
